<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式在 src/styles/index.css 中定义 */
</style>
